<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <div class="d-flex flex-column align-center">
        <br>Vous pouvez rejoindre l'association
        <br>en nous renvoyant ce bulletin d'adhésion
        <br>accompagné du chéque d'adhésion à l'ordre de SELIDAIRE.
        <v-btn variant="text" href="/bulletin_adhesion_2027.pdf" target="_blank" download>
          <v-icon size="large">mdi-file-document</v-icon>
        </v-btn>
      </div>
    </v-slide-y-transition>
  </v-container>
</template>
